import React from 'react';
import styles from '../../DataExtractionTemplate.module.scss';
import InterventionsFields from './InterventionsFields';
import CharacteristicsFields from './CharacteristicsFields';
import InterventionsPopoversList from './InterventionsPopoversList';
import { Heading, Text } from 'components/core';

interface Props {
  hasExtractedData?: boolean;
}

const InterventionsMainContent = ({ hasExtractedData = false }: Props) => {
  return (
    <>
      <Heading type="h5" component="h4" variant="neutral">
        Interventions
      </Heading>
      <InterventionsPopoversList />
      <InterventionsFields hasExtractedData={hasExtractedData} />
      <div className={styles.details} data-testid="characteristics">
        <Heading type="h5" component="h4" variant="neutral">
          Intervention details
        </Heading>
        <Text className={styles.ExtractionHeadingSubtext}>
          For each intervention reported in the study, what details do you want
          to collect?
        </Text>
        <CharacteristicsFields hasExtractedData={hasExtractedData} />
      </div>
    </>
  );
};

export default InterventionsMainContent;
